module.exports = __webpack_public_path__ + "static/media/frog(26).f3fe2317.PNG";